angular.module('impactx.sapconfig').controller('SAPEKOListController', [
    'selectedListItems',
    SAPEKOListController]);

function SAPEKOListController(selectedListItems) {
    var ctrl = this;

    this.getDetailLink = function() {
        return "sapeko/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'SAPEKO'}
    ];

    this.meta = {
        rowTemplate: 'modules/sapconfig/templates/sapekolist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/sapconfiguration/ekolist',
        ctrl: this,
        id: "sapekolist",
        mainAction : {id:"new", link: "#/sapeko/0", icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function() {
        return this.meta;
    };
}